var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"applicant"}},[_vm._v("\n    检测站申请接入\n")])}
var staticRenderFns = []

export { render, staticRenderFns }